import React, { useState, useEffect, useRef } from 'react';
import SEO from '../../components/common/SEO';
import anwar from '../../assets/images/anwar.png';
import amjad from '../../assets/images/amjad.png';
import cs  from '../../assets/images/cs.png';
import gm  from '../../assets/images/gm.png';
import cfo from '../../assets/images/cfo.png';
import ol  from '../../assets/images/ol.png';
import bl  from '../../assets/images/bl.png';
import dl  from '../../assets/images/dl.png';
import lp from '../../assets/images/lp.jpg';
import dm from '../../assets/images/dm.jpg';

const directors = [
  {
    id: 1,
    name: 'Lt Gen Anwar Ali Hyder, HI (M), (Retd)',
    title: 'Chairman',
    image: anwar,
    invertLayout: false,
    shortBio: 'With nearly four decades of distinguished military service, Lieutenant General Anwar Ali Hyder (Retired) brings consummate skill and experience in planning, organization and administration to his present assignment. Throughout his distinguished career he held prestigious positions in various command, staff and instructional roles, culminating in the position of Principal Staff Officer to the Chief of Army Staff as Adjutant General of Pakistan Army.',
    fullBio: `With nearly four decades of distinguished military service, Lt Gen Anwar Ali Hyder (Retd) brings consummate skills and experience in planning, organization, and administration to his present assignment. Throughout his distinguished career with the Pakistan Army, he held prestigious command, staff, and instructional positions, culminating in the position of Principal Staff Officer to the Chief of Army Staff as Adjutant General of the Pakistan Army.

In this role, he spearheaded several important welfare initiatives and large-scale commercial projects at the Army and national level, including strategizing the development and growth of Fauji Foundation Companies and serving as the Chairman of Army Welfare Trust.

He made noteworthy contributions to the planning and development of Defence Housing Authorities all over the country and supervised the development and management of countrywide mega housing projects such as Askari Housing Colonies.

He also had the distinctive opportunity to make contributions in the academic domain as President of the National Defence University and as a member of the Board of Governors of NUST, NUMS and NUTECH.

Transitioning seamlessly into the civilian leadership role, Gen Hyder assumed the chairmanship of Naya Pakistan Housing and Development Authority and played an important role in the interim Federal Cabinet as the caretaker minister for Defence and Defence Production. He also served as a member of the Apex Committee of the Special Investment Facilitation Council (SIFC), where he made multifaceted contributions to national economic growth initiatives and, in the process, remained engaged with several public and private sector entities and multinational organizations.

His strategic prowess and commitment to excellence are complimented by his professional and academic qualifications, which include a Master of Strategic Studies from US Army War College, Carlisle, Pennsylvania and an MSc degree in War Studies from National Defence University, Islamabad. His dedication to duty and meritorious services in the Pakistan Army were duly recognized through conferment of the Chief of Army Staff Commendation Card and the prestigious Hilal-e-Imtiaz (Military) by the President of Pakistan.`,
    directorships: {
      listed: [
        'Fauji Fertilizer Company Limited',
        'Fauji Cement Company Limited',
        'Askari Bank Limited',
        'Fauji Fertilizer Bin Qasim Limited',
        'Fauji Foods Limited',
        'MariEnergies',
      ],
      nonListed: [
        'Fauji Akbar Portia Marine Terminals Limited',
        'Fauji Trans Terminal Limited',
        'Fauji Oil Terminal and Distribution Company Limited',
        'Foundation Power Company Daharki Limited',
        'Fauji Kabirwala Power Company Limited',
        'Foundation Solar Energy (Private) Limited',
        'Daharki Power Holdings Limited',
        'Mari Minerals (Pvt) Limited',
        'Mari Technologies Limited',
      ],
    },
  },
  {
    id: 2,
    name: 'Maj Gen Amjad Ahmed Butt, HI (M), (Retd)',
    title: 'CEO / MD',
    image: amjad,
    invertLayout: true,
    shortBio: 'During his nearly four decades of military service, he has vast and varied experience on command, staff and instructional assignments. Key positions held include Commandant Military College of Signals (MCS), DG C4I, DG (Tech) of Strategic Organization and Signals Officer-in-Chief at General Headquarters, Pakistan Army.',
    fullBio: `Major General Amjad Ahmed Butt, was commissioned in Pakistan Army in September 1987. During his nearly four decades of military service, he has vast and varied experience on command, staff and instructional assignments. Key positions held include Commandant Military College of Signals (MCS), DG C4I, DG (Tech) of Strategic Organization and Signals Officer-in-Chief at General Headquarters, Pakistan Army.

The General is a graduate of Command & Staff College, Quetta and National Defence University, Islamabad. He holds masters degrees in Art and Science of Warfare from University of Balochistan and War Studies & Defence Management from National Defence University, Islamabad. In recognition of his meritorious services, he has been conferred with the award of Hilal-i-Imtiaz (Military).

Major General Amjad Ahmed Butt joined Fauji Foundation on 15 August 2024 as its CEO/MD Power Vertical.`,
    directorships: { listed: [], nonListed: [] },
  },
];

const seniorTeam = [
  {
    name: 'Brig (R) Imran Kashfi',
    title: 'Company Secretary',
    image: cs,
    shortBio: 'Brigadier Imran is a seasoned and results-driven leader with over 36 years of distinguished service in diverse and demanding roles across strategic planning, human resource management, administration and operations.',
    fullBio: `Brigadier Imran is a seasoned and results-driven leader with over 36 years of distinguished service in diverse and demanding roles across strategic planning, human resource management, administration and operations. His career in the Pakistan Army, culminating in the rank of Brigadier, reflects a consistent record of excellence in leadership and institutional management.

Throughout his military career, he held key positions spanning command, staff and instructional roles. He brings to FSEL a deep understanding of organizational governance, strategic planning frameworks, and large-scale operational management — skills honed over decades of service at the highest levels of the Pakistan Army.

His post-retirement role as Company Secretary at Foundation Solar Energy Limited reflects his transition into the corporate sector, where he continues to apply his extensive experience in administration, compliance and institutional coordination to support the company's growth and governance objectives.`,
  },
  {
    name: 'Brig (R) Shahid Javed Hussain',
    title: 'General Manager',
    image: gm,
    shortBio: 'Brig Shahid Javed Hussain (Retd) brings extensive experience of active service in Intelligence Agencies, Strategic Organizations and Civil Armed Forces, with deep expertise in Financial Management, Legal matters, Commercial Projects and Land Matters.',
    fullBio: `Brig Shahid Javed Hussain (Retd) brings infinite experience of active service in Intelligence Agencies, Strategic Organizations and Civil Armed Forces, with collaboration across Government Departments and Public Sector outfits. He possesses expertise in Financial Management, Legal matters, Commercial Projects and Land Matters within the domain of Corporate culture, combined with excellent communication skills acquired through wide-ranging interaction with officials at various tiers of Government and Public sector departments.

His core competencies span administrative leadership with comprehensive knowledge of human resource management, successful execution of Security Operations in collaboration with Law Enforcement Agencies, Intelligence operations through interaction with various intelligence agencies, and Excellence in Financial Management across organizations of various capacities.

He further brings expertise in handling Land matters including acquisition and litigation, efficient handling of Commercial Projects with special focus on Contracting, Legal Expertise through handling multi-dimensional litigation cases, and effective communication and liaison with Officials of various Government Departments and Ministries.

He holds qualifications including FSc from Government College Lahore (1987), Bachelor of Arts from Pakistan Military Academy Abbottabad (1992), and Master of Science and Arts of Warfare from Command and Staff College Quetta (2004). He has also completed a Senior Officers' Command Course (2016) — Brigade Commanders' Course in China with special focus on strategic planning under diverse environments — and the NATO-sponsored Law of Armed Conflict Course in Turkey (2016).`,
  },
  {
    name: 'Tughral Salman',
    title: 'Chief Financial Officer',
    image: cfo,
    shortBio: "With professional experience spanning over two decades, Mr Salman is an adaptable, conscientious and self-motivated individual with wide-ranging exposure in Pakistan's power sector — IPPs, energy and natural resources, renewable energy and professional services.",
    fullBio: `With professional experience spanning over two decades, Mr Salman is an adaptable, conscientious, enthusiastic, and self-motivated individual with a wide ranged exposure in Pakistan's power sector — IPPs (including experience of two major power policies), energy and natural resources (ENI sector), renewable energy (RE sector) and professional services sector.

He has been trained at one of the Big Four Professional Services Firms — KPMG Taseer Hadi & Co (a member firm of KPMG International) — and perseveres to achieve results, possessing excellent communication skills combined with the ability to relate well to people at all levels.

At present, he is managing a portfolio of three companies of Fauji Group namely Foundation Power Company Daharki Limited (FPCDL – a 180 MW CCPP), Fauji Kabirwala Power Company Limited (FKPCL – a 157 MW CCPP) and Foundation Solar Energy Pvt Limited (FSEL – Solar Energy company) as Group Chief Financial Officer and serving as a Board Member on the Board of Management of Fongas (Fauji Group flagship project in energy – LPG sector).

He holds professional memberships of the Institute of Chartered Accountants of England and Wales (ICAEW), Association of Chartered Certified Accountants (ACCA-UK) and Institute of Certified Public Accountants of Pakistan (ICPAP) and is a member in good standing.`,
  },
];

const teamLeads = [
  { name: 'Engr. Hammad Ahmed',      title: 'Head of Operations',          image: ol },
  { name: 'Taimur',                  title: 'Head of Business Development', image: bl },
  { name: 'Hafiz Omer',              title: 'Head of Design',               image: dl },
  { name: 'Khizer Naveed',           title: 'Lead Projects',                image: lp },
  { name: 'Umar Bin Abdul Hameed',   title: 'DM Tech',                      image: dm },
];

// senior team profile modal
function SeniorModal({ person, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(0,0,0,0.75)' }} onClick={onClose}>
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto"
        onClick={e => e.stopPropagation()}>
        <div className="bg-gradient-to-br from-slate-900 to-blue-900 rounded-t-3xl px-6 pt-10 pb-8 text-center relative">
          <button onClick={onClose} className="absolute top-4 right-4 text-white/60 hover:text-white transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <div className="w-28 h-28 rounded-full mx-auto mb-5 border-4 border-yellow-400 overflow-hidden shadow-xl">
            <img src={person.image} alt={person.name} className="w-full h-full object-cover" />
          </div>
          <h2 className="text-xl font-bold text-white leading-snug mb-1 px-4">{person.name}</h2>
          <p className="text-yellow-400 font-semibold text-base">{person.title}</p>
        </div>
        <div className="px-6 py-8 space-y-4">
          {person.fullBio.split('\n\n').map((para, i) => (
            <p key={i} className="text-gray-600 leading-relaxed text-sm">{para}</p>
          ))}
        </div>
      </div>
    </div>
  );
}

// director profile modal
function ProfileModal({ person, onClose }) {
  const hasDirectorships =
    person.directorships.listed.length > 0 ||
    person.directorships.nonListed.length > 0;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(0,0,0,0.7)' }} onClick={onClose}>
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto"
        onClick={e => e.stopPropagation()}>
        <div className="bg-gradient-to-br from-slate-900 to-blue-900 rounded-t-3xl px-6 pt-10 pb-8 text-center relative">
          <button onClick={onClose} className="absolute top-4 right-4 text-white/60 hover:text-white transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <div className="w-28 h-28 rounded-full mx-auto mb-5 border-4 border-yellow-400 overflow-hidden shadow-xl">
            <img src={person.image} alt={person.name} className="w-full h-full object-cover" />
          </div>
          <h2 className="text-xl font-bold text-white leading-snug mb-1 px-4">{person.name}</h2>
          <p className="text-yellow-400 font-semibold text-base">{person.title}</p>
        </div>
        <div className="px-6 py-8 space-y-6">
          <div className="space-y-4">
            {person.fullBio.split('\n\n').map((para, i) => (
              <p key={i} className="text-gray-600 leading-relaxed text-sm">{para}</p>
            ))}
          </div>
          {hasDirectorships && (
            <div className="border-t border-gray-100 pt-6">
              <h3 className="text-gray-900 font-bold text-lg mb-4">Board Directorships</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {person.directorships.listed.length > 0 && (
                  <div>
                    <p className="text-xs font-bold uppercase tracking-widest text-blue-700 mb-3">FF Group — Listed</p>
                    <ul className="space-y-2">
                      {person.directorships.listed.map((company, i) => (
                        <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                          <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-yellow-400 flex-shrink-0"></span>
                          {company}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {person.directorships.nonListed.length > 0 && (
                  <div>
                    <p className="text-xs font-bold uppercase tracking-widest text-blue-700 mb-3">FF Group — Non-Listed</p>
                    <ul className="space-y-2">
                      {person.directorships.nonListed.map((company, i) => (
                        <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                          <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0"></span>
                          {company}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// director card
function DirectorCard({ person, onViewProfile }) {
  return (
    <div className="bg-white rounded-3xl shadow-lg border border-gray-100 overflow-hidden">
      <div className="flex flex-col md:grid md:grid-cols-3 md:gap-0">

        <div className={`bg-gradient-to-br from-slate-900 to-blue-900 flex flex-col items-center justify-center py-10 px-8 gap-6
          ${person.invertLayout ? 'md:order-first' : 'md:order-last'} order-first`}>
          <div className="w-32 h-32 md:w-36 md:h-36 rounded-2xl overflow-hidden border-2 border-yellow-400 shadow-xl">
            <img src={person.image} alt={person.name} className="w-full h-full object-cover" />
          </div>
          <button
            onClick={() => onViewProfile(person)}
            className="px-6 py-2.5 bg-yellow-400 text-blue-900 font-bold text-sm rounded-xl hover:bg-yellow-300 transition-all duration-200 hover:scale-105 shadow-md"
          >
            View Profile
          </button>
        </div>

        <div className="md:col-span-2 p-8 md:p-14 flex flex-col justify-between">
          <div>
            <div className="mb-5">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 leading-snug">{person.name}</h2>
              <span className="inline-block mt-2 px-3 py-1 bg-blue-50 text-blue-700 text-sm font-semibold rounded-full border border-blue-100">
                {person.title}
              </span>
            </div>
            <div className="w-12 h-1 bg-gradient-to-r from-blue-600 to-yellow-400 rounded-full mb-5"></div>
            <p className="text-gray-500 leading-relaxed text-sm">{person.shortBio}</p>
          </div>
        </div>

      </div>
    </div>
  );
}

// scroll-reveal wrapper
function AnimatedCard({ children, delay = 0 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.05 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} style={{
      opacity: visible ? 1 : 0,
      transform: visible ? 'translateY(0px)' : 'translateY(60px)',
      transition: `opacity 0.8s ease ${delay}ms, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms`,
    }}>
      {children}
    </div>
  );
}

// animated divider
function AnimatedDivider() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} className="flex items-center gap-4 my-10"
      style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.8s ease' }}>
      <div className="flex-1 h-px bg-gradient-to-r from-transparent via-blue-200 to-transparent"></div>
      <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#facc15', transform: visible ? 'scale(1)' : 'scale(0)', transition: 'transform 0.5s ease 0.3s' }} />
      <div className="flex-1 h-px bg-gradient-to-r from-transparent via-blue-200 to-transparent"></div>
    </div>
  );
}

// section header
function SectionHeader({ label, title, subtitle, light = false }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} className="text-center mb-12"
      style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(24px)', transition: 'opacity 0.7s ease, transform 0.7s ease' }}>
      <p style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: light ? '#facc15' : '#1e3a8a', marginBottom: '12px' }}>{label}</p>
      <h2 style={{ fontSize: 'clamp(24px, 5vw, 42px)', fontWeight: 700, color: light ? '#ffffff' : '#0a1628', marginBottom: '14px', lineHeight: 1.15 }}>{title}</h2>
      <div style={{ width: '56px', height: '3px', background: 'linear-gradient(to right, #1d4ed8, #facc15)', borderRadius: '2px', margin: '0 auto 16px' }} />
      {subtitle && <p style={{ fontSize: '0.95rem', color: light ? 'rgba(255,255,255,0.7)' : '#64748b', maxWidth: '520px', margin: '0 auto', lineHeight: 1.75, padding: '0 8px' }}>{subtitle}</p>}
    </div>
  );
}

// main page
function Governance() {
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [selectedSenior, setSelectedSenior] = useState(null);

  return (
    <div className="bg-white min-h-screen">
      <SEO title="Board of Directors" description="Meet the leadership and board of directors of Foundation Solar Energy Limited." url="/bod" />

      {/* page header */}
      <section className="bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 py-16 md:py-20 text-center relative overflow-hidden">
        <div style={{ position: 'absolute', inset: 0, opacity: 0.04, backgroundImage: 'linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)', backgroundSize: '48px 48px' }} />
        <div style={{ position: 'relative', zIndex: 1 }} className="px-4">
          <p style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#facc15', marginBottom: '14px' }}>
            Foundation Solar Energy Limited
          </p>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">Governance</h1>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-400 to-yellow-400 mx-auto mb-5"></div>
          <p className="text-blue-200 text-base md:text-lg max-w-xl mx-auto leading-relaxed px-4">
            The leadership and people that guide Foundation Solar Energy's vision, values, and growth.
          </p>
        </div>
      </section>

      {/* executive leadership section */}
      <section className="py-14 md:py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader
            label="Governance"
            title="Executive Leadership"
            subtitle="Decades of distinguished service guiding our strategic direction and institutional growth."
          />
          {directors.map((person, index) => (
            <div key={person.id}>
              {index > 0 && <AnimatedDivider />}
              <AnimatedCard delay={index * 100}>
                <DirectorCard person={person} onViewProfile={setSelectedPerson} />
              </AnimatedCard>
            </div>
          ))}
        </div>
      </section>

      <div style={{ height: '3px', background: 'linear-gradient(to right, #1d4ed8, #facc15, #1d4ed8)' }} />

      {/* meet our team section */}
      <section className="py-14 md:py-20 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 relative overflow-hidden">
        <div style={{ position: 'absolute', inset: 0, opacity: 0.04, backgroundImage: 'linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)', backgroundSize: '48px 48px' }} />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <SectionHeader
            label="Our People"
            title="Meet Our Team"
            subtitle="The dedicated professionals behind every project, innovation, and milestone at FSEL."
            light={true}
          />

          <AnimatedCard delay={0}>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-5">
              {seniorTeam.map((member, i) => (
                <div key={i} style={{ background: 'rgba(255,255,255,0.06)', borderRadius: '16px', borderTop: '3px solid #facc15', textAlign: 'center', padding: '28px 20px 24px' }}>
                  <div style={{ width: '88px', height: '88px', borderRadius: '50%', border: '2px solid #facc15', overflow: 'hidden', margin: '0 auto 16px', background: 'rgba(250,204,21,0.1)' }}>
                    <img src={member.image} alt={member.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                  <p style={{ fontSize: '15px', fontWeight: 700, color: '#ffffff', marginBottom: '4px' }}>{member.name}</p>
                  <p style={{ fontSize: '12px', fontWeight: 500, color: '#facc15', letterSpacing: '0.04em', marginBottom: '14px' }}>{member.title}</p>
                  <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.55)', lineHeight: 1.6, marginBottom: '18px', padding: '0 4px' }}>{member.shortBio}</p>
                  <button
                    onClick={() => setSelectedSenior(member)}
                    style={{ padding: '8px 20px', background: '#facc15', color: '#0a1628', fontWeight: 700, fontSize: '12px', borderRadius: '10px', border: 'none', cursor: 'pointer', transition: 'all 0.2s ease' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#fde047'}
                    onMouseLeave={e => e.currentTarget.style.background = '#facc15'}
                  >
                    View Profile
                  </button>
                </div>
              ))}
            </div>
          </AnimatedCard>

          <div style={{ height: '1px', background: 'rgba(255,255,255,0.1)', margin: '8px 0 24px' }} />

          <AnimatedCard delay={150}>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
              {teamLeads.map((member, i) => (
                <div key={i} style={{ background: 'rgba(255,255,255,0.07)', borderRadius: '14px', borderTop: '2px solid rgba(250,204,21,0.4)', textAlign: 'center', padding: '20px 12px 18px' }}>
                  <div style={{ width: '60px', height: '60px', borderRadius: '50%', border: '2px solid rgba(250,204,21,0.5)', overflow: 'hidden', margin: '0 auto 12px', background: 'rgba(255,255,255,0.06)' }}>
                    <img src={member.image} alt={member.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                  <p style={{ fontSize: '12px', fontWeight: 700, color: '#ffffff', marginBottom: '5px', lineHeight: 1.3 }}>{member.name}</p>
                  <p style={{ fontSize: '10px', fontWeight: 500, color: '#facc15', letterSpacing: '0.03em', lineHeight: 1.4 }}>{member.title}</p>
                </div>
              ))}
            </div>
          </AnimatedCard>

        </div>
      </section>

      {selectedPerson && <ProfileModal person={selectedPerson} onClose={() => setSelectedPerson(null)} />}

      {selectedSenior && <SeniorModal person={selectedSenior} onClose={() => setSelectedSenior(null)} />}

    </div>
  );
}

export default Governance;